import { create } from 'zustand';

interface FloatingChatState {
  intercomOpen: boolean;
  setIntercomOpen: (open: boolean) => void;
}

export const useFloatingChat = create<FloatingChatState>((set) => ({
  intercomOpen: false,
  setIntercomOpen: (open) => set({ intercomOpen: open }),
}));
